import { transformNestedObjectToObject } from "./common";

export const transformFilterQueriesToObject = (
  filterQueries: Record<string, any>[]
): Record<string, any> => {
  return filterQueries.reduce((prev, acc) => {
    const object = transformNestedObjectToObject(acc);
    return {
      ...prev,
      ...object,
    };
  }, {});
};
